import * as React from 'react'

export const SVG_Delete = (props: { color?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="23" viewBox="0 0 20 23" color={props.color || '#4F5B68'}>
        <g fill="none" fillRule="nonzero">
            <g stroke="currentColor" strokeLinecap="round" strokeWidth="2.1">
                <path d="M7.934 10.101v6.838M12.066 10.101v6.838" />
            </g>
            <path
                fill="currentColor"
                d="M7.457 4.12h4.74V2.38a.59.59 0 0 0-.587-.596H8.043a.59.59 0 0 0-.586.595v1.742zM8.043 0h3.567c1.163 0 2.129.857 2.315 1.982.022.13.033.262.033.397v2.384H5.696V2.38C5.696 1.065 6.746 0 8.043 0z"
            />
            <path
                stroke="currentColor"
                strokeWidth="1.8"
                d="M3.375 4.94V20.3a1.8 1.8 0 0 0 1.8 1.8h9.355a1.8 1.8 0 0 0 1.8-1.8V4.94H3.375z"
            />
            <path stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" d="M1 4.914h17.852" />
        </g>
    </svg>
)
